export const FETCH_SIZES_REQUEST = 'FETCH_SIZES_REQUEST';
export const FETCH_SIZES_SUCCESS = 'FETCH_SIZES_SUCCESS';
export const FETCH_SIZES_FAILURE = 'FETCH_SIZES_FAILURE';

export const ADD_SIZE_REQUEST = 'ADD_SIZE_REQUEST';
export const ADD_SIZE_SUCCESS = 'ADD_SIZE_SUCCESS';
export const ADD_SIZE_FAILURE = 'ADD_SIZE_FAILURE';

export const UPDATE_SIZE_REQUEST = 'UPDATE_SIZE_REQUEST';
export const UPDATE_SIZE_SUCCESS = 'UPDATE_SIZE_SUCCESS';
export const UPDATE_SIZE_FAILURE = 'UPDATE_SIZE_FAILURE';

export const DELETE_SIZE_REQUEST = 'DELETE_SIZE_REQUEST';
export const DELETE_SIZE_SUCCESS = 'DELETE_SIZE_SUCCESS';
export const DELETE_SIZE_FAILURE = 'DELETE_SIZE_FAILURE';

export const SET_SIZE_EDIT = 'SET_SIZE_EDIT';
export const CLEAR_SIZE_EDIT = 'CLEAR_SIZE_EDIT'; 